import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectDashboardState } from '../dashboard.selectors';
import * as fromDevice from '../device/device.reducer';
export const selectDeviceState = createSelector(selectDashboardState, (dashboard) => dashboard?.device);

export const selectSelectedDevice = createSelector(selectDeviceState, (deviceState) => deviceState?.selectedDevice);

export const selectDevices = createSelector(selectDeviceState, fromDevice.selectAll);
